module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/suset-1-5f5ccf27e1cd3e91bba10a434acfe2c8.svg";